<template>
  <div id="app">
    <!-- <img src="./assets/logo.png"> -->
    <router-view/>
    <!-- <vue-progress-bar></vue-progress-bar> -->
  </div>
</template>

<script>
export default {
  name: 'app'
}
</script>

<script>
// import { getOpenId } from './api/common'
// import wx from 'weixin-js-sdk' // 微信引入
// import { getCookie } from '@/utils/auth'
export default {
  mounted () {
    //  [App.vue specific] When App.vue is finish loading finish the progress bar
    this.$Progress.finish()
  },
  created () {
    //  [App.vue specific] When App.vue is first loaded start the progress bar
    this.$Progress.start()
    //  hook the progress bar to start before we move router-view
    this.$router.beforeEach((to, from, next) => {
      //  does the page we want to go to have a meta.progress object
      if (to.meta.progress !== undefined) {
        let meta = to.meta.progress
        // parse meta tags
        this.$Progress.parseMeta(meta)
      }
      //  start the progress bar
      this.$Progress.start()
      //  continue to next page
      next()
    })
    //  hook the progress bar to finish after we've finished moving router-view
    this.$router.afterEach((to, from) => {
      //  finish the progress bar
      this.$Progress.finish()
    })
  }
  // watch: {
  //   '$route'(to, from) {
  //     const share = ['/course/courseDetail']
  //     if (share.indexOf(to.path) !== -1) {
  //       getOpenId({url: getCookie('theurl')}).then(response => {
  //         var data = response.data
  //         wx.config({
  //           debug: false,
  //           appId: data.WX_APPID,
  //           timestamp: data.WX_TIMESTAMP,
  //           nonceStr: data.WX_NONCESTR,
  //           signature: data.WX_SIGNATURE,
  //           jsApiList: [
  //             'onMenuShareAppMessage',
  //             'onMenuShareTimeline'
  //           ]
  //         })
  //         wx.ready(function() {
  //           wx.onMenuShareAppMessage({
  //             desc: getCookie('desc'), // 分享描述
  //             title: getCookie('courseName'), // 分享标题
  //             link: 'https://yunxiao.daishujianbao.com/course/courseDetail?id=' + getCookie('courseId') + '&title=' + encodeURIComponent(getCookie('courseName')) + '&share_uid=' + getCookie('uid'), // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
  //             imgUrl: getCookie('imgsrc') // 分享图标
  //           })
  //           wx.onMenuShareTimeline({
  //             title: getCookie('courseName'), // 分享标题
  //             desc: getCookie('desc'), // 分享描述
  //             link: 'https://yunxiao.daishujianbao.com/course/courseDetail?id=' + getCookie('courseId') + '&title=' + encodeURIComponent(getCookie('courseName')) + '&share_uid=' + getCookie('uid'), // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
  //             imgUrl: getCookie('imgsrc') // 分享图标
  //           })
  //         })
  //       })
  //     } else {
  //       getOpenId({url: getCookie('theurl'), pid: getCookie('ten_pid')}).then(response => {
  //         var data = response.data
  //         wx.config({
  //           debug: false,
  //           appId: data.WX_APPID,
  //           timestamp: data.WX_TIMESTAMP, // 必填，生成签名的时间戳
  //           nonceStr: data.WX_NONCESTR, // 必填，生成签名的随机串
  //           signature: data.WX_SIGNATURE, // 必填，签名，见附录1
  //           jsApiList: [
  //             'hideAllNonBaseMenuItem'
  //           ] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
  //         })
  //         wx.ready(function () {
  //           wx.hideAllNonBaseMenuItem()
  //         })
  //       })
  //     }
  //   }
  // }
}
</script>

<style lang="scss">
* {
  -webkit-appearance: none;
}
#app {
  font-family: 'microsoft yahei', Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-size: 14px;
  color: #4d4d4d;
  height: 100%;
}
html, body {
  overflow-y: auto;
  overflow-x: hidden;
  /* 禁用iOS橡皮筋效果 - 这个是必要的 */
  overscroll-behavior: none;
  -webkit-overscroll-behavior: none;
}
/* 解决ios返回空白页面 */
/* html, body {
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  position: relative;
}
#app {
  width: 100%;
  height: 100%;
  background: #fff;
  overflow: scroll;
  -webkit-overflow-scrolling: touch;
  position: absolute;
  left:0;
  top:0;
} */

.cube-picker-confirm, .cube-picker-cancel {
  font-size: 15px !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue